(function () {
  const el = document.getElementById('minship');
  if (!el) return;

  const threshold = parseInt(el.dataset.threshold || '5000', 10);
  const moneyFormat = el.dataset.moneyFormat || "${{amount}}";
  const locale = (el.dataset.locale || 'en').toLowerCase();

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    try {
      // Devine la devise active si possible, sinon CAD
      const currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
      return (cents / 100).toLocaleString(locale === 'fr' ? 'fr-CA' : 'en-CA', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  async function refreshMinShip() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const total = cart.total_price || 0;

      if (total >= threshold) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
        const gap = threshold - total;
        const gapEl = el.querySelector('.minship__gap');
        if (gapEl) gapEl.textContent = formatMoney(gap);
      }
    } catch (err) {
      // silencieux
    }
  }

  // Petit debounce pour éviter les appels en rafale
  let t;
  const debouncedRefresh = () => {
    clearTimeout(t);
    t = setTimeout(refreshMinShip, 150);
  };

  // Écoute les events "classiques" et ceux utilisés par de nombreux thèmes
  document.addEventListener('cart:updated', debouncedRefresh);
  document.addEventListener('cart:change', debouncedRefresh);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'updates[]' || e.target.closest('.quantity'))) {
      debouncedRefresh();
    }
  });
  document.addEventListener('click', function (e) {
    if (
      e.target.matches('.quantity__button, .js-qty-btn, button[name="plus"], button[name="minus"]')
      || e.target.closest('.quantity__button')
    ) {
      debouncedRefresh();
    }
  });

  // Sur beaucoup de thèmes (incluant le tien), le drawer se re-render :
  const target = document.getElementById('drawer-cart') || document.querySelector('interactive-cart');
  if (target && 'MutationObserver' in window) {
    new MutationObserver(debouncedRefresh).observe(target, { childList: true, subtree: true });
  }

  // Premier calcul
  refreshMinShip();
})();
